import { useCookieConsentVar } from '@context/CookieConsentProvider';
import { useCookieConsent } from '@cvent/cookieconsent';
import { useEffect } from 'react';
/**
 * This component saves the cookie consent choices from the cookie consent provider to an @apollo/client var. Saving the cookie consent choices to a var allows components outside the cookie consent provider to get the latest settings.
 */
function UpdateCookieConsentVar() {
  const { canSetFunctionalityCookies, canSetMarketingCookies, canSetPerformanceCookies } = useCookieConsent();
  const { setCookieConsent } = useCookieConsentVar();

  useEffect(() => {
    setCookieConsent({
      Performance: canSetPerformanceCookies,
      Marketing: canSetMarketingCookies,
      Functionality: canSetFunctionalityCookies
    });
  }, [canSetFunctionalityCookies, canSetMarketingCookies, canSetPerformanceCookies, setCookieConsent]);

  return null;
}

export default UpdateCookieConsentVar;
